import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import TableRow from '../../../../components/Table/TableRow';
import activityLogIcon from '../../../../assets/images/activity-log-empty-state.png';
import TableHeader from '../../../../components/Table/TableHeader';
import dataModel from '../../../../models/DataModel';

import './ActivityLogTable.scss';
import LoadingDots from '../../../../components/LoadingDots';

export class ActivityLogTable extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      sortedType: this.props.sortField,
      sortAsc: this.props.ascending,
    };
  }

  componentDidUpdat2(prevProps) {
    if (prevProps.accent != this.props.accent) {
      this.setState({ accent: this.props.accent });
    }
  }

  handleScrolling() {
    const listRect = this.list.getBoundingClientRect();
    const scrollRect = this.scroller.getBoundingClientRect();
    if (!this.infiniteDone &&
      listRect.bottom <= scrollRect.bottom + 12 && 
      !this.scrollinProgress &&
      ((this.props.eventHistories && this.props.eventHistories.length < this.props.totalEventHistories))
    ) {
      this.scrollinProgress = true;
      this.setState({ loadingMore: true });

      if (this.props.getMoreEventhistories) {
        this.props.getMoreEventhistories((fetchedEventHistories) => {
          if (fetchedEventHistories.length >= this.props.totalEventHistories) {
            this.infiniteDone = true;
          }
          this.handledLoadMoreOnTransition = false;
          this.scrollinProgress = false;
          this.setState({ loadingMore: false });
        });
      }
    }
  }

  handleSort(type, direction) {
    if (type == this.state.sortedType && direction == 'up' && this.state.sortAsc) {
      this.setState({ sortedType: null });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null);
    }
    else if (type == this.state.sortedType && direction == 'down' && !this.state.sortAsc) {
      this.setState({ sortedType: null  });
      this.infiniteDone = false;
      this.props.handleSortChange(null, null);
    }
    else {
      this.props.handleSortChange(type, direction == 'up' ? true : false);
      this.infiniteDone = false;
      
      this.setState({
        sortedType: type,
        sortAsc: direction == 'up' ? true : false, 
      });
    }
  }

  handleCreateActivityRows(){
    let even = false;
    let rows;
    if (this.props.eventHistories) {
      let actualActivities = this.props.eventHistories.map(activity => {
        // map to fields needed in <TableRow>
        const user = activity.user_who_performed_action;
        if (user) {
          activity.first_name = user.first_name;
          activity.last_name = user.last_name;
        }
        else {
          activity.first_name = 'Unknown';
          activity.last_name = 'User';
        }
        return activity;
      });

      rows = actualActivities.map(activity => {
        even = !even;
        return (
            <TableRow
              key={activity.id}
              selectedItem={ activity }
              even={ even }
              type={'activity-log'}
              notClickable={true}
            />
          );
      });
    }

    return rows;
  }

  handleCaretSelection(direction) {
    this.direction = direction;
  }

  handleSetScroller(element) {
    if (element && !this.scroller) {
      this.scroller = element;
      this.scroller.addEventListener('scroll', this.handleScrolling);
    }
  }

  render() {
    let { accent } = this.props;
    const sortDirectionClass  = this.state.sortAsc ? '' : 'down';

    let caretTypes = [
      { type: 'activity', headerName: this.textMap.activity.toUpperCase(), first: true }, 
      { type: 'activity_sub_type', headerName: this.textMap.subType.toUpperCase() }, 
      { type: 'first_name', headerName: this.textMap.firstName.toUpperCase() },
      { type: 'last_name', headerName: this.textMap.lastName.toUpperCase() }, 
      { type: 'created_at', headerName: this.textMap.timeStamp.toUpperCase() },
      { type: 'company_name', headerName: this.textMap.company.toUpperCase() },
      { type: 'description', headerName: this.textMap.description.toUpperCase() },
    ];

    let tableHeader = (
      <TableHeader 
        accent={ accent } 
        sortDirectionClass={ sortDirectionClass }
        handleSort={ this.handleSort }
        sortedType={ this.state.sortedType }
        caretTypes={ caretTypes } 
        reportType={'activity-log'}
      />
    );

    let activityRows = this.handleCreateActivityRows();

    let loadingMore = null;
    
    if (this.state.loadingMore) {
      loadingMore = <div className="loading-more-indicator"><LoadingDots /></div>;
    }

    if (!this.props.inProgress && (!activityRows || activityRows.length == 0)) {
      if (this.props.filter || this.props.searchString) {
        activityRows = <div className="no-matches-indicator">No Results Found...</div>;
      }
      else if (!this.props.refresh){
        tableHeader = null;
        let noActivityLogs = <div className="no-users">There is no activity for this company.</div>;
        activityRows = <div className='no-users-container'>
          <img className='activity-icon' src={activityLogIcon} alt='icon' />
          {noActivityLogs}
        </div>;
      }
    }

    return <div className={'activity-log-table' + (this.props.filterDisplayed ? ' activity-log-table__filter-enabled' : '')}>
      {tableHeader}  
      <div className={'activity-log-scroller infinite-scrolling'} ref={(element) => this.handleSetScroller(element)}>  
        <div className='activity-log-rows' ref={(element) => {
          this.list = element;
        }}>
          {activityRows}
          {loadingMore}
        </div>
      </div>  
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  let accent = state.new_companies.currentCompany ? state.new_companies.currentCompany.accent_color : null;

  return {
    dataModel: dataModel,
    permissions: state.new_users.permissions,
    accent: accent,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activitiesList: state.activityLogs.activitiesList,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogTable);




// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ActivityLog/ActivityLogTable/index.js